/**
 * PricingSection.tsx
 * 料金関連: 全項目インライン編集
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import InlineEditField from '../shared/InlineEditField';

interface PricingSectionProps extends SectionProps {
  onRecalcClick?: () => void;
}

export default function PricingSection({
  data,
  onChange,
  disabled,
  onOpenEditMulti,
  onRecalcClick,
}: PricingSectionProps) {
  const toggleStyle = (active: boolean) => ({
    padding: '2px 8px',
    fontSize: '0.75rem',
    fontWeight: active ? 700 : 400,
    border: active ? '1px solid #3b82f6' : '1px solid #cbd5e1',
    borderRadius: 4,
    cursor: disabled ? 'default' : 'pointer',
    background: active ? '#3b82f6' : '#e2e8f0',
    color: active ? '#ffffff' : '#64748b',
    boxShadow: 'none',
  });

  return (
    <>
      <SectionHeader title="料金" />
      <InlineEditField
        label="基本料金"
        field="base_price"
        value={data.base_price}
        onChange={onChange}
        disabled={disabled}
        type="number"
        suffix="円"
      />
      <InlineEditField
        label="オプション料金"
        field="option_price"
        value={data.option_price}
        onChange={onChange}
        disabled={disabled}
        type="number"
        suffix="円"
      />
      <InlineEditField
        label="オプション内容"
        field="option"
        value={data.option}
        onChange={onChange}
        disabled={disabled}
        type="textarea"
      />

      {/* NOC */}
      <div className="gc-field">
        <label className="gc-label" style={{ fontSize: '0.85rem', color: '#64748b' }}>NOC</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            type="button"
            style={toggleStyle(!!data.noc)}
            onClick={() => !disabled && onChange?.({ noc: !data.noc })}
          >
            NOC
          </button>
          <InlineEditField
            label=""
            field="noc_price"
            value={data.noc_price}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="円"
          />
        </div>
      </div>

      {/* CDW */}
      <div className="gc-field">
        <label className="gc-label" style={{ fontSize: '0.85rem', color: '#64748b' }}>CDW</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button
            type="button"
            style={toggleStyle(!!data.cdw)}
            onClick={() => !disabled && onChange?.({ cdw: !data.cdw })}
          >
            CDW
          </button>
          <InlineEditField
            label=""
            field="cdw_price"
            value={data.cdw_price}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="円"
          />
        </div>
      </div>

      <InlineEditField
        label="クーポン"
        field="coupon"
        value={data.coupon}
        onChange={onChange}
        disabled={disabled}
      />
      <InlineEditField
        label="ポイント"
        field="point"
        value={data.point}
        onChange={onChange}
        disabled={disabled}
        type="number"
        suffix="pt"
      />

      <div className="gc-field" style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="泊数"
            field="nights"
            value={data.nights}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="泊"
          />
        </div>
        <div style={{ flex: 1 }}>
          <InlineEditField
            label="日数"
            field="days"
            value={data.days}
            onChange={onChange}
            disabled={disabled}
            type="number"
            suffix="日"
          />
        </div>
      </div>

      {/* 合計金額 (highlighted) */}
      <InlineEditField
        label="合計金額"
        field="sum_price"
        value={data.sum_price}
        onChange={onChange}
        disabled={disabled}
        type="number"
        suffix="円"
      />

      {onRecalcClick && (
        <div style={{ padding: '0 4px 8px' }}>
          <button
            type="button"
            disabled={disabled}
            onClick={onRecalcClick}
            style={{
              padding: '2px 12px',
              fontSize: '0.75rem',
              border: '1px solid #3b82f6',
              borderRadius: 4,
              background: '#fff',
              color: '#3b82f6',
              cursor: disabled ? 'default' : 'pointer',
            }}
          >
            再計算
          </button>
        </div>
      )}
    </>
  );
}
